import { useEffect, useState } from "react";
import { useStateValue } from "../context/StateProvider";
import { countPostsSince } from "../utils/firebasefunctions";

const POLL_MS = 60000;

// Returns the number of feed posts created since the current user last opened
// the Feed. Re-checks on mount, every 60s, and whenever lastSeenFeedAt changes.
export default function useUnreadFeedCount() {
  const [{ user }] = useStateValue();
  const lastSeen = Number(user?.lastSeenFeedAt) || 0;
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user?.id) return;
    let cancelled = false;

    const check = async () => {
      try {
        const c = await countPostsSince(lastSeen);
        if (!cancelled) setCount(c);
      } catch (err) {
        console.error("Failed to count unread feed posts:", err);
      }
    };

    check();
    const id = setInterval(check, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [user?.id, lastSeen]);

  return count;
}
